module.exports = __webpack_public_path__ + "img/spo2.7872e623.png";